import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { graphql } from "react-apollo";
import { queryGetNotification } from "Apollo";
import { observer } from "mobx-react";
import Icon from "module-common/Icon";
import { ServiceAlertStore, CaseManagementStore, SelectCase } from "Store";

export default graphql(queryGetNotification, { name: "notification" })(
  observer(
    class ServiceAlert extends Component {
      static propTypes = {
        case: PropTypes.array
      };

      // componentWillReceiveProps(nextProps) {
      //   const { notification } = nextProps;
      //   const notificationValue = notification.getNotification;

      //   if (notificationValue) {
      //     if (notificationValue.notificationGroup.length !== 0) {
      //       let store = ServiceAlertStore.currentState;
      //       store.isShown = true;
      //       store.count = notificationValue.notificationGroup.length;
      //       store.message = notificationValue.notificationGroup[0].content;
      //       store.case = [];
      //       notificationValue.notificationGroup.map(row => {
      //         store.case.push({
      //           id: row.id,
      //           caseId: row.caseId,
      //           username: row.channelHandlerUsername,
      //           content: row.content
      //         });
      //       });
      //     }
      //   }
      // }

      render() {
        const { currentState } = ServiceAlertStore;
        const { selectedCase } = CaseManagementStore;
        const renderUsername = currentState.case.map((row, index) => {
          const isSelected = selectedCase && selectedCase.id === row.caseId;
          return (
            <Customer
              key={index}
              selected={isSelected}
              onClick={caseId => this.findData(row.caseId)}
              {...currentState.pickCase}
            >
              @{row.username}
            </Customer>
          );
        });

        return (
          <Wrapper isShown={currentState.isShown}>
            <AlertWrapper>
              <Title>
                You have {currentState.count} cases which are almost reaching
                SLA deadline
              </Title>
              <IconRow
                width={10}
                height={10}
                name="x-button"
                onClick={() => {
                  currentState.isShown = false;
                }}
              />
            </AlertWrapper>
            <CustomerWrapper>{renderUsername}</CustomerWrapper>
            <Message>
              {currentState.count > 1 ? null : currentState.message}
            </Message>
          </Wrapper>
        );
      }

      findData = caseId => {
        const { currentState } = ServiceAlertStore;
        let pickCase = this.props.case.find(obj => {
          return obj.id === caseId;
        });
        return (currentState.pickCase = pickCase);
      };
    }
  )
);

const Wrapper = styled.div`
  padding: 10px;
  background: #f8cf19;
  ${props =>
    props.isShown
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `};
  flex-direction: column;
`;

const AlertWrapper = styled.div`
  justify-content: space-between;
  display: flex;
`;
const Title = styled.div`
  font-weight: bold;
`;

const CustomerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Customer = styled.span`
  border-radius: 4px;
  margin-top: 7px;
  padding: 3px;
  cursor: pointer;
  :hover {
    background: #e2b900;
    cursor: pointer;
  }
`;

const Message = styled.div`
  margin-top: 5px;
`;

const IconRow = styled(Icon)`
  color: #a74036;
  align-self: center;
`;



// WEBPACK FOOTER //
// ./src/module-common/ServiceAlert.js